<template>
  <ul>
    <li v-for="(item,index) in 10"
        :key="index"
        :class="{checked: curCheckedIndex === index}">
      <div class="questions-wrap">
        <div class="user-info">
          <img class="avatar"
               src="../../../assets/logo.png"
               alt="">
          <span class="username">积极向上的小明同学</span>
        </div>
        <div class="msg-wrap">
          <div class="msg">
            哈哈哎哈奥哈或哈或或或或或
          </div>
        </div>
        <p class="time gray ft12">2019-07-27 14:50:24</p>
        <div class="reply-deal">
          <el-button type="primary"
                     size="mini"
                     @click="reply(index)"
                     v-if="curCheckedIndex !== index">回复</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="cancelReply(index)"
                     v-else>取消</el-button>
        </div>
      </div>
      <div class="reply-wrap"
           v-if="!(index%4)">
        <div class="user-info">
          <el-button class="recall"
                     type="text">撤回</el-button>
          <span class="role gray">讲师</span>
          <span class="username">葛鹏</span>
          <img class="avatar"
               src="../../../assets/logo.png"
               alt="">
        </div>
        <div class="msg-wrap">
          <div class="msg">
            哈哈哎哈奥哈或哈或或或或或
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      curCheckedIndex: -1,
    }
  },
  methods: {
    reply (index) {
      this.curCheckedIndex = index
    },
    cancelReply () {
      this.curCheckedIndex = -1
    }
  }
}
</script>

<style lang="less" scoped>
li {
  padding: 5px;
  border: 1px solid @border-color;
  border-radius: 4px;
  &.checked {
    border-color: @blue;
  }
  & + li {
    margin-top: 15px;
  }
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.username {
  display: inline-block;
  max-width: 87px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msg {
  margin-top: 10px;
  padding: 10px;
  background-color: @table-bg;
  border: 1px solid @border-color;
  font-size: 12px;
  line-height: 15px;
  display: inline-block;
}
.time {
  margin-top: 10px;
  margin-left: 34px;
}
.user-info {
  display: flex;
  align-items: center;
}
.questions-wrap {
  padding-bottom: 10px;
  .reply,
  .role,
  .username {
    margin-left: 10px;
  }
  .msg-wrap {
    text-align: left;
  }
  .msg {
    margin-left: 34px;
    border-radius: 0 10px 10px 10px;
  }
  .reply-deal {
    margin-top: 10px;
    text-align: right;
  }
}
.reply-wrap {
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid @border-color;
  .user-info {
    justify-content: flex-end;
  }
  .recall {
    padding: 0;
  }
  .recall,
  .role,
  .username {
    margin-left: 0;
    margin-right: 10px;
  }
  .msg-wrap {
    text-align: right;
  }
  .msg {
    margin-right: 34px;
    border-radius: 10px 0 10px 10px;
    background-color: @blue;
    color: #ffffff;
  }
}
</style>


